import type {
  AndroidPushMessageGet,
  AndroidPushMessagePost,
  IosPushMessageGet,
  IosPushMessagePost,
  KindlePushMessageGet,
  KindlePushMessagePost,
  WebPushMessageGet,
  WebPushMessagePost,
} from "@schemas/types";

type PushMessageData =
  | AndroidPushMessageGet
  | AndroidPushMessagePost
  | IosPushMessageGet
  | IosPushMessagePost
  | KindlePushMessageGet
  | KindlePushMessagePost
  | WebPushMessageGet
  | WebPushMessagePost;

export interface PushMessageTextsByField {
  title: string[];
  body: string[];
}

const nonEmpty = (value: string | null | undefined): value is string => !!value && value.length > 0;

/**
 * Extracts a push message's title and body texts into separate buckets so that
 * validators can attribute errors to the offending field. Unlike
 * {@link extractPushMessageTexts}, this does not collapse into a single
 * "generic" bucket.
 */
export const extractPushMessageTextsByField = (messageData: PushMessageData): PushMessageTextsByField => {
  switch (messageData.message_type) {
    case "androidPush":
      return {
        title: [messageData.android_title].filter(nonEmpty),
        body: [messageData.android_push_message].filter(nonEmpty),
      };
    case "iosPush":
      return {
        title: [messageData.ios_alert_hash?.title].filter(nonEmpty),
        body: [messageData.ios_push_message].filter(nonEmpty),
      };
    case "webPush":
      return {
        title: [messageData.web_title].filter(nonEmpty),
        body: [messageData.web_push_message].filter(nonEmpty),
      };
    case "kindlePush":
      return {
        title: [messageData.kindle_title].filter(nonEmpty),
        body: [messageData.kindle_push_message].filter(nonEmpty),
      };
  }
};
